(function() {
  window.adConfigs = window.adConfigs || {};

  const flavours = ['Caramel', 'Peanut Butter', 'Pistachio', 'Raspberry', 'Hazelnut', 'Malt Cornflakes'];

  function buildFlavourList(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    return 'Six bars: ' + reordered.join(' · ');
  }

  function buildFlavourChips(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    const chips = reordered.map((f, i) =>
      `<span class="bb-flavour-chip">${f}</span>${i < reordered.length - 1 ? ' <span class="bb-sep">·</span> ' : ''}`
    ).join('');
    return `<span style="color: #5b4637;">Six handmade filled chocolate bars</span><br>${chips} <a href="/pages/build-your-box" class="bb-build-link">– Customise →</a>`;
  }

  const socialProof = '★★★★★ Best chocolate I\'ve had in ages.';

  const selftreatImages = {
    'caramel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self_Treat_Caramel.png?v=1776269836',
    'peanutbutter': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self-Treat-Peanut-Butter-PDP.png?v=1775653052',
    'pistachio':    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Pistachio_self_treat.png?v=1776268428',
    'raspberry':    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_cropped.png?v=1774430529',
    'pretzel':      null,
    'smaltz':       'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self-treat-smaltz.png?v=1776079070',
    'smaltz2':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/SelfTreat-Smaltz-PDP.png?v=1776264730',
    'smaltzbranded': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Smaltz_logo_self_treat.png?v=1776428059',
  };

  const selftreatFlavours = {
    'caramel':      'Caramel',
    'peanutbutter': 'Peanut Butter',
    'pistachio':    'Pistachio',
    'raspberry':    'Raspberry',
    'pretzel':      'Hazelnut',
    'smaltz':       'Malt Cornflakes',
    'smaltz2':      'Malt Cornflakes',
    'smaltzbranded':      'Malt Cornflakes',
    
  };

  Object.entries(selftreatFlavours).forEach(([key, displayName]) => {
    const pdpImage = selftreatImages[key];
    const flavourList = buildFlavourList(displayName);
    const flavourChips = buildFlavourChips(displayName);

    // Version A — box in cart (no cartImage)
    window.adConfigs[`selftreat-${key}`] = {
      subline1:  "Not a gift.<br>This one's for you",
      subline2:  flavourChips,
      cartSub:   flavourList,
      image:     pdpImage,
      cartImage: null,
      socialProof,
    };

    // Version B — PDP image in cart
    window.adConfigs[`selftreat-${key}-pdpcart`] = {
      subline1:  "Not a gift.<br>This one's for you",
      subline2:  flavourChips,
      cartSub:   flavourList,
      image:     pdpImage,
      cartImage: pdpImage,
      socialProof,
    };
  });
})();